import { cn } from '@src/lib/utils';

import { ProcessFieldStringField } from './ProcessFieldStringField';

import { useTranslation } from 'react-i18next';

export function ProcessFieldStringFieldAiChat({
    className,
    fieldProps,
    placeholder,
    ...props
}: React.ComponentProps<typeof ProcessFieldStringField>) {
    const { t } = useTranslation();

    return (
        <ProcessFieldStringField
            {...props}
            placeholder={placeholder ?? t('translation:enterAnswer')}
            className={cn(
                'mb-0! w-full gap-0! [&>label]:mb-0! [&>label]:w-full! [&>label]:border-b [&>label]:border-solid [&>label]:border-(--color-card-text)/10 [&>label]:px-[18px] [&>label]:py-4 [&>label]:text-sm! [&>label]:leading-5! [&>label]:font-medium! [&>.serviceFormMessage]:mx-[18px] [&>.serviceFormMessage]:mb-3',
                '[&>.group]:mx-[18px] [&>.group]:my-3 [&>.group]:w-[calc(100%-36px)]! [&>.group]:rounded-xl',
                '[&>.group:focus-within]:outline-2! [&>.group:focus-within]:outline-solid! [&>.group:focus-within]:outline-(--color-brand-green)! [&>.group[aria-invalid=true]]:outline-1! [&>.group[aria-invalid=true]]:outline-solid! [&>.group[aria-invalid=true]]:outline-(--color-danger)!',
                className,
            )}
            fieldProps={{
                ...fieldProps,
                className: cn(
                    'rounded-xl! border-0! bg-(--color-ai-file-upload-bg)! px-4! py-2! text-sm! leading-5! font-medium! text-(--color-card-text)! placeholder:text-(--color-neutral-6)!',
                    'h-12!',
                    fieldProps?.className,
                ),
            }}
        />
    );
}
